import React, { FC } from 'react'

import { ArrowUpTrayIcon } from '@heroicons/react/24/outline'

import { useAppDispatch } from '@/client/hooks'
import { MODALS, setActiveModal } from '@/features/FileManager/fileManagerSlice'

export const FolderMenu: FC = () => {
  const dispatch = useAppDispatch()

  const handleFileUpload = () => {
    dispatch(setActiveModal(MODALS.Upload))
  }

  return (
    <div className='flex items-center justify-start'>
      <button
        type='button'
        className='btn btn-primary btn-sm flex gap-0.5 items-center justify-center'
        onClick={handleFileUpload}
      >
        <ArrowUpTrayIcon
          width={20}
          className='mr-1'
        />
        Upload files
      </button>
    </div>
  )
}
